<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="jointType_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Joint Type -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.JOINT_TYPE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #jointType_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.JOINT_TYPE' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="flangeType"
        name="joint_type"
        class="mat-select-general input-form-class"
        [class.spinner]="loading"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let ftl of flangeTypeList" [value]="ftl.flangeTypeId">{{ ftl.flangeTypeName }}</mat-option>
    </mat-select>
</div>
